import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useBreadcrumbSettings = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.BREADCRUMB_SETTINGS(),
    queryFn: () => shopApi.fetchBreadcrumbSettings(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.BREADCRUMB_SETTINGS(),
    });
  };

  return {
    isLoading,
    isFetching,
    breadcrumbSettings: data?.data,
    invalidate,
  };
};
